import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';
import { PRICING, PROJECTS } from '../../shared/routes/path';
import './TrialEndedPage.scss';
import useDisabledAccount from '../../shared/hooks/account/UseDisabledAccount';
import { useAccount } from '../../shared/contexts/account/AccountContexts';
import { TRIAL_ADVISOR } from '../../shared/constans/constans';

const TrialEndedPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isDisabled } = useDisabledAccount();
  const { accountResponse } = useAccount();


  if (accountResponse?.accountType !== 'TRIAL' && isDisabled === true) {
    return <Navigate to={PRICING} />;
  }

  if (isDisabled === false) {
    return <Navigate to={PROJECTS} />;
  }

  const handlePurchasePlan = () => {
    navigate(PRICING);
  };

  return (
    <div className="page-content page-content--trial-ended">
      <div className="page-box">
        <div className="page-box__content">
          <div className="page-box__stats">
            <div className="trial-ended-page__content">
              <h1 className="trial-ended-page__title">
                {t('trialEndedTitle')}
              </h1>

              <div className="trial-ended-page__description">
                {t('trialEndedDescription')}
              </div>

              <div className="trial-ended-page__sections" role="main">
                {/* Sekcja pomocy */}
                <div className="trial-ended-page__section" role="region" aria-labelledby="help-section-title">
                  <div className="trial-ended-page__section-header">
                    <span className="trial-ended-page__icon" role="img" aria-label="envelope">✉️</span>
                    <h3 className="trial-ended-page__section-title" id="help-section-title">
                      {t('needHelpOrQuestions')}
                    </h3>
                  </div>
                  <div className="trial-ended-page__section-content">
                    <span className="trial-ended-page__text">
                      {t('emailUsAt')}{' '}
                      <a 
                        href={`mailto:${TRIAL_ADVISOR.email}`}
                        className="trial-ended-page__link"
                        aria-label={`${t('emailUsAt')} ${TRIAL_ADVISOR.email}`}
                      >
                        {TRIAL_ADVISOR.email}
                      </a>{' '}
                      {t('orBookCall')}
                      <a 
                        href={TRIAL_ADVISOR.calendly}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="trial-ended-page__link"
                        aria-label={`${t('bookCall')} ${t('opensInNewTab')}`}
                      >
                        {t('bookCall')}
                      </a>.
                    </span>
                  </div>
                </div>

                <div className="trial-ended-page__section" role="region" aria-labelledby="continue-section-title">
                  <div className="trial-ended-page__section-header">
                    <span className="trial-ended-page__icon" role="img" aria-label="credit card">💳</span>
                    <h3 className="trial-ended-page__section-title" id="continue-section-title">
                      {t('readyToContinue')}
                    </h3>
                  </div>
                  <div className="trial-ended-page__section-content">
                    <div className="trial-ended-page__button-container">
                      <button
                        className="trial-ended-page__button"
                        onClick={handlePurchasePlan}
                        aria-label={t('purchasePlan')}
                      >
                        {t('purchasePlan')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="trial-ended-page__footer" role="contentinfo">
                <span className="trial-ended-page__footer-text">
                  <span className="trial-ended-page__emoji" role="img" aria-label="rocket">🚀</span> {t('weLoveToHaveYouBack')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialEndedPage;
